export const showWeight = (weightInG: string | undefined) =>
  !!weightInG && parseInt(weightInG) !== 0;

export const showComponents = <T extends object>(
  components: T[] | undefined,
): components is T[] => !!components && components.length > 0;

export const showMaterial = (material: string | undefined) =>
  !!material && material !== '-';
